import icX from 'assets/images/ic-x.svg'
import icScanBarcode from 'assets/images/ic-scan.svg'
import { Button, Modal } from 'avo-ui'
import DOMPurify from 'dompurify'

export const ScanBarcodeModal = ({ show, onHide, onChangeHandler, orderId, isLoading }) => {
    return (
        <Modal dialogClassName={'w-fit'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <div className={'flex px-3 pt-3 justify-end'}>
                <img className={'w-5 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
            </div>
            <div className={'flex flex-col items-center text-center space-y-8 p-5'}>
                <img src={icScanBarcode} className={'scale-75'} alt={'icScanBarcode'} />
                <p className={'italic w-4/5 text-base'}>
                    Arahkan laser scanner pada barcode yang tersedia pada kode pesanan
                </p>
                <div>
                    <p className={'text-base'}>Kode Pesanan</p>
                    <p className={'italic'}>Arahkan kursor pada kolom di bawah</p>
                </div>
                <div className={'flex items-center space-x-1 border border-neutral-50 rounded-full w-3/5 h-8 px-5'}>
                    <p>MSBB -</p>
                    <input
                        onChange={(e) => onChangeHandler(DOMPurify.sanitize(e?.target?.value))}
                        id={'scanBarcode'}
                        value={orderId}
                        className={'outline-none flex-1 autofocus'}
                        disabled={isLoading}
                    />
                </div>
            </div>
            <div className={'flex items-center justify-center py-5 bg-blue-5'}>
                <Button title={'Selesai'} onClick={onHide} />
            </div>
        </Modal>
    )
}
